import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { SolicitudResponse } from "../../../shared/response/proyectos/ProyectoResponse";
import { SolicitudPayload } from "../../../shared/services/api/payload/proyectos/SolicitudPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { toSolicitudResponse } from "./ProyectoService";

/**
 * Pide una cantidad de un ítem del proyecto (solo Nitrofert). No alimenta ningún listado: la pantalla recarga el
 * detalle del proyecto después de pedirla.
 */
export class SolicitudSaveService extends ServiceSaveBase<SolicitudResponse, SolicitudPayload> {
  /** gRPC-Web (`SolicitarCantidad`): Nitrofert la atiende registrando gastos por NitrofertApi. */
  protected async sendSave(p: SolicitudPayload): Promise<SolicitudResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).solicitarCantidad({
      proyectoId: p.proyectoId,
      itemId: p.itemId,
      cantidad: p.cantidad,
      observaciones: p.observaciones ?? undefined,
    }));
    return toSolicitudResponse(r);
  }
}
